import styled from "styled-components";

const SLiderImageContainer = styled.div`
    // width: 270px;
    // height: 380px;
    // margin-right: 10px;
    padding: 0 5px;
`;
export default SLiderImageContainer;
